module.exports = __webpack_public_path__ + "img/S__90480701.171526d1.jpg";